import { Form as FormikForm } from 'formik';
import styled from 'styled-components/macro';
import {
  fontSize,
  neutral,
  radius,
  shadow,
  space,
} from '../../../theme/tokens';
import { StaffSubHeader } from '../../staff/elements/User';

export const Form = styled(FormikForm)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${space[4]};
  width: 100%;
  margin-top: ${space[5]};
  padding: ${space[5]} ${space[4]};
  background: ${({ theme }) => theme.appBackground};
  border: 1px solid ${neutral.border};
  border-radius: ${radius.lg};
  box-shadow: ${shadow.sm};
`;

export const FormHeader = styled(StaffSubHeader)`
  padding: 0;
  font-size: ${fontSize.xl};
  text-align: center;
`;

export const FormSpacer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 48rem;
  & > *:not(button) {
    width: 100%;
  }
`;

export * from '../../common/elements/Form';
export * from '../../common/elements/Staff';
